import { Api } from "./api"

export class DormantAccountApi extends Api {
  constructor() {
    super('company/activate_dormant_account', ['subscriptionCustomerId'])
  }
}
